import React, { ReactNode, useState, useRef, Fragment, useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";


interface ModalProps {
    children?: ReactNode | ReactNode[];
    openModal: boolean;
}
const AuthenticationModal = ({openModal, children}:ModalProps) => {
    const [open, setOpen] = useState(openModal ? openModal : false);
    const [dontClose, setDontClose] = useState(false);
    return (
        <>
         <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="w-auto relative z-10" onClose={setDontClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className=" w-auto fixed inset-0 z-10 overflow-y-auto ">
            <div className="flex h-auto w-auto items-center justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className=" relative transform  rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-640 sm:p-6">
                {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
        </>
    );
}
export default AuthenticationModal;